import appConstants from '@appConstants';
import { MultiSelectFilter, DateTimeFilter } from '@dataGrid/components/columnFilters';
import { formatDateTime } from '@dataGrid/gridUtilities';

export default class GridConfig {
  config: ReturnType<typeof GridConfig.getDefaultConfiguration>;

  constructor() {
    this.config = GridConfig.getDefaultConfiguration();
  }

  static getDefaultConfiguration() {
    return {
      title: 'CustomerAliasesGrid',
      keyColumn: 'rowId',
      defaultColDef: {
        sortable: true,
        resizable: true,
        editable: false,
        filter: MultiSelectFilter
      },
      columns: [
        {
          headerName: 'Acc#',
          headerTooltip: 'Acc#',
          colId: 'customerCode',
          // Show the account number only for non-misc customers
          valueGetter: (params: any) =>
            params.data?.isMiscCustomer ? '' : params.data?.customerCode,
          filter: MultiSelectFilter,
          minWidth: appConstants.columnWidth.CUSTOMER_CODE
        },
        {
          headerName: 'Customer Name',
          headerTooltip: 'Customer Name',
          field: 'customerName',
          tooltipField: 'customerName',
          tooltipValueGetter: (params: any) => params.value,
          filter: MultiSelectFilter,
          flex: 1,
          minWidth: appConstants.columnWidth.CUSTOMER
        },
        {
          headerName: 'Address',
          headerTooltip: 'Address',
          field: 'customerAddress',
          tooltipField: 'customerAddress',
          tooltipValueGetter: (params: any) => params.value,
          filter: MultiSelectFilter,
          flex: 1,
          minWidth: appConstants.columnWidth.CUSTOMER_ADDRESS
        },
        {
          headerName: 'City',
          headerTooltip: 'City',
          field: 'customerCity',
          filter: MultiSelectFilter,
          minWidth: appConstants.columnWidth.CITY
        },
        {
          headerName: 'State',
          headerTooltip: 'State',
          field: 'customerState',
          filter: MultiSelectFilter,
          minWidth: appConstants.columnWidth.STATE
        },
        {
          headerName: 'Zip',
          headerTooltip: 'Zip',
          field: 'customerZip',
          filter: MultiSelectFilter,
          minWidth: appConstants.columnWidth.ZIP_CODE
        },
        {
          headerName: 'Last Merged On',
          headerTooltip: 'Last Merged On',
          field: 'lastModifiedDateTime',
          valueFormatter: formatDateTime,
          filter: DateTimeFilter,
          filterParams: { DATETYPE: appConstants.DATETYPES.DATETIME },
          minWidth: appConstants.columnWidth.W_140
        },
        {
          headerName: 'Last Merged By',
          headerTooltip: 'Last Merged By',
          field: 'lastModifiedUserName',
          tooltipField: 'lastModifiedUserName',
          tooltipValueGetter: (params: any) => params.value,
          filter: MultiSelectFilter,
          minWidth: appConstants.columnWidth.W_180
        }
      ]
    };
  }
}
